// extracted by mini-css-extract-plugin
export var aiStarIcon = "_da-4";
export var closeButton = "_da-6";
export var dismissButton = "_da-3";
export var editImageWithAiContainer = "_da-8";
export var imageUploadWrapper = "_da-7";
export var misspelledWord = "_da-5";
export var spellCheckContainer = "_da-2";
export var spin = "_da-1";
export var spinning = "_da-0";